import { StaticToast } from 'src/components/common';
import { timSdkLogout, timSdkUpdateConfig, timSdkDataDynamicUpdate } from 'src/store/im/action';
import { nimSdkGetHistoryMessageList, nimSdkReceiveMessage } from 'src/store/im/action';
import { pushIMInquiryEndNoticeOrOther } from 'src/store/inquiry/action';
import { timCustomData } from 'src/store/im/utils';

class NIMSDKIM {
  public nim;
  public scrllBottom;
  public readyState = 0; // 0 、1、2、3 与websocket状态保持一致
  public NIMSDK;
  constructor() {}
  init(data) {
    import('./NIM_Web_SDK_v8.7.0.js').then(NIMSDK => {
      console.log(data, 'data');
      this.NIMSDK = NIMSDK;
      this.nim = NIMSDK.NIM.getInstance({
        debug: true,
        db: false,
        ...data,
        //链接成功的问调，并已经自动登录
        onconnect: () => {
          console.log('链接成功');
          window.globalStore.dispatch(timSdkDataDynamicUpdate({ timIsReady: true }));
          window.globalStore.dispatch(timSdkUpdateConfig({ currentConversationID: data.roomId }));
          window.globalStore.dispatch(timSdkDataDynamicUpdate({ userInfo: { ...data, username: data.account } }));
          this.readyState = 1;
          window.globalStore.dispatch(nimSdkGetHistoryMessageList({}));
        },
        onwillreconnect: () => {},
        ondisconnect: (error) => {
          // 此时说明 SDK 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
          // 此时说明 SDK 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
          console.log('丢失连接', error);
          if (error) {
            this.readyState = 3;
            /*switch (error.code) {
              // 账号或者密码错误, 请跳转到登录页面并提示错误
              case 302:
                break;
              // 重复登录, 已经在其它端登录了, 请跳转到登录页面并提示错误
              case 417:
                break;
              // 被踢, 请提示错误后跳转到登录页面
              case 'kicked':
                break;
              default:
                break;
            }*/
            error.message&&StaticToast.error(error.message || '链接已断开');
            window.location.replace('/hospital/myinquiry');
  
          }
        },
        onerror: (error) => {
          console.log(error, '出错');
        },
        onmsg: (msgs) => {
          console.log('收到消息', msgs);
          this.onWatchTimEndEvent(msgs);
          if (!Array.isArray(msgs)) {
            msgs = [msgs];
          }
          window.globalStore.dispatch(nimSdkReceiveMessage(msgs, true));
        },
      });
    })
  }

  TIMInstance() {
    return this.nim;
  }

  IMlisten(options) {}
  onReadyStateUpdate({ name }) {
    const isSDKReady = name === this.NIMSDK.EVENT.SDK_READY;
    console.log('~~~--isSDKReady---', name, isSDKReady);
    window.globalStore.dispatch(timSdkDataDynamicUpdate({ timIsReady: isSDKReady }));
    if (isSDKReady) {
      let { videos: { timIsGroupReady = false } = {} } = window.globalStore.getState();
      if (timIsGroupReady) {
        this.readyState = 1;
        window.globalStore.dispatch(nimSdkGetHistoryMessageList({}));
      }
      this.nim.getMyProfile().then((res) => {
        let { code = '', data = {} } = res;
        if (code === 0) {
          window.globalStore.dispatch(timSdkDataDynamicUpdate({ userInfo: { ...data, username: data.userID } }));
        }
      });
    }
  }
  onError(event) {
    console.log('SDK ERROR~', event);
    let { data: { message = '', code = '' } = {} } = event;
    if (message && code && code !== 2800 && code !== 2999) {
      StaticToast.error(message || '服务异常');
      this.readyState = 3;
    }
  }
  onWatchTimEndEvent(msgs) {
    let { type = '', content = '{}' } = msgs;
    if (type === 'custom') {
      const { customEvent = '' } = timCustomData(content);
      if (customEvent == 'CMD_010') {
        // inquiryStatus: 4, 不再更新状态，仅更新前端输入框的展示
        window.globalStore.dispatch(pushIMInquiryEndNoticeOrOther({ fakeInquiryStatus: 4 }));
      }
    }
  }
  logout() {
    try {
      window.globalStore.dispatch(timSdkLogout());
      this.nim.disconnect && this.nim.disconnect();
      this.readyState = 0;
    } catch (error) {}
  }
}

export default new NIMSDKIM();
